import { Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const styles = theme => ({
  button: {
    width: '50%',
    height: '36px',
    padding: '0',
    border: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
    borderRadius: 0,
    color: `var(--gameday-tabs-tabActiveColor, ${theme.tabs.tabActiveColor})`,
    '&:focus': {
      outline: 'none',
    },
    '&:not(.active)': {
      backgroundColor: `var(--gameday-tabs-tabBackgroundColor, ${theme.tabs.tabBackgroundColor})`,
      color: `var(--gameday-tabs-tabInActiveColor, ${theme.tabs.tabInActiveColor})`,
      fontWeight: theme.typography.fontWeightNormal,
    },
  },
})

const ButtonGroupButton = ({ active, children, classes, onClick, ...rest }) => (
  <Button className={cn({ active }, classes.button)} onClick={onClick} {...rest}>
    {children}
  </Button>
)

const ButtonComponent = withStyles(styles)(ButtonGroupButton)
ButtonComponent.displayName = 'ButtonGroupButton'
export default ButtonComponent
